import { useState } from "react";
import HospitalOrderVolumePanel from "../../components/distributor/HospitalOrderVolumePanel";
import { DISTRIBUTOR_METRICS_DEFAULT_FILTER } from "../../helpers/metricsPeriod";
import { useOrderSocket } from "../../hooks/useOrderSocket";
import "./distributor.css";

export default function VaDistributorHospitalVolume() {
  const [filter, setFilter] = useState(DISTRIBUTOR_METRICS_DEFAULT_FILTER);
  // Soft-refresh hospital volume when admin creates/assigns a VA order.
  useOrderSocket({ enabled: true });

  return (
    <div className="distributor-dashboard hospital-volume-page">
      <HospitalOrderVolumePanel
        filter={filter}
        onFilterChange={setFilter}
      />
    </div>
  );
}
